import React from "react";
import { TbSun, TbMoon, TbDeviceDesktop } from "react-icons/tb";
import { useTheme } from "../../ThemeContext";

// Appearance, in the top bar rather than buried in account settings.
//
// The theme itself already existed — ThemeContext carries light/dark/system, persists it
// and follows the OS live — but the only control for it sat on the pre-login pages, so
// once you signed in there was no way to change it. Three options, not two: "follow the
// system" is a real choice a two-state switch cannot express.
//
// Its own module so the staff shell renders the same control as the customer shell
// without importing the whole of ShellV2.
const THEME_MODES = [
  { value: "light", label: "Light", icon: TbSun },
  { value: "dark", label: "Dark", icon: TbMoon },
  { value: "system", label: "Follow system", icon: TbDeviceDesktop },
];

const ThemeToggle = () => {
  const { mode, setMode } = useTheme();
  return (
    <div className="v2-theme-toggle" role="group" aria-label="Appearance">
      {THEME_MODES.map(({ value, label, icon: Icon }) => (
        <button key={value} type="button" title={label} aria-label={label}
                aria-pressed={mode === value}
                className={mode === value ? "on" : ""}
                onClick={() => setMode(value)}>
          <Icon size={14} />
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle;
